export const ordersContentForCircularCard = (
  totalWaitingOrders,
  totalProcessingOrders,
  totalShippedOrders,
  totalFailedOrders
) => {
  const circularContent = [
    {
      amount: totalWaitingOrders?.totalAmount || 0,
      id: 1,
      percent: totalWaitingOrders?.percentage,
      text: totalWaitingOrders?.percentage,
      items: totalWaitingOrders?.count,
      type: "Waiting",
      link: "/orders",
    },
    {
      amount: totalProcessingOrders?.totalAmount || 0,
      id: 2,
      percent: totalProcessingOrders?.percentage,
      text: totalProcessingOrders?.totalAmount,
      items: totalProcessingOrders?.count,
      link: "/orders",
      type: "Processing",
    },
    {
      amount: totalShippedOrders?.totalAmount || 0,
      id: 3,
      percent: totalShippedOrders?.percentage,
      text: totalShippedOrders?.totalAmount,
      items: totalShippedOrders?.count,
      link: "/orders",
      type: "Shipped",
    },
    {
      amount: 0,
      id: 4,
      percent: totalFailedOrders?.percentage,
      text: 0,
      items: totalFailedOrders?.count,
      link: "/orders",
      type: "Failed",
    },
  ];

  return circularContent
};
